import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

/**
 * Rich-text editor for one recipient's email preview (SendEmails).
 *
 * Why the `source` check: the carousel reuses one editor for every recipient and
 * swaps its `value` when you change card. react-quill applies that new value inside
 * shouldComponentUpdate, i.e. BEFORE React gives it the new props, and Quill hands
 * back its own re-formatted HTML through onChange. That callback is still the
 * PREVIOUS card's, so the next person's body was written into the previous
 * person's slot (name and email mixed up — IGFEMS-596). Only real typing
 * (`source === "user"`) should update a recipient's draft.
 */
const EmailPreviewEditor = ({ value, onChange, placeholder }) => (
  <ReactQuill
    theme="snow"
    value={value || ""}
    onChange={(content, _delta, source) => {
      if (source !== "user") return;
      onChange(content);
    }}
    placeholder={placeholder}
  />
);

export default EmailPreviewEditor;
